import {
    DownloadFileTracker,
} from './DownloadFileTracker';

interface QueueItem {
    index: number;
    value: DownloadFileTracker;
}

export class Queue {
    private changeEvent: () => void;

    constructor(changeEvent: () => void) {
        this.changeEvent = changeEvent;
        this.items = [];
    }

    add(value: DownloadFileTracker, index: number) {
        value.queued = true;
        let item: QueueItem = {
            index: index,
            value: value
        };
        this.items.push(item);

        this.changeEvent();
    }

    remove(index: number) {
        let item: QueueItem = null;
        let i: number = 0;
        while (i < this.items.length) {
            if (this.items[i].index === index) {
                item = this.items[i];
                break;
            }
            i++;
        }
        if (item === null) {
            return;
        }
        item.value.queued = false;
        this.items.splice(i, 1);

        if (this.items.length === 0) {
            // Kön är aktiv tills användaren stoppar den. Finns inte längre några filer att stoppa kan vi aktivera den igen.
            this.start();
        }

        this.changeEvent();
    }

    removeAll() {
        for (let i = 0; i < this.items.length; i++) {
            this.items[i].value.queued = false;
        }
        this.items = [];
        this.start();

        this.changeEvent();
    }

    dequeueNext(): QueueItem | null {
        if (!this.active) {
            return null;
        }
        var nextIndex = this.items.shift();
        if (nextIndex === undefined) {
            return null;
        }
        nextIndex.value.queued = false;

        this.changeEvent();
        return nextIndex;
    }

    start() {
        this.active = true;

        this.changeEvent();
    }

    stop() {
        this.active = false;

        this.changeEvent();
    }

    getPosition(index: number) {
        for (let i = 0; i < this.items.length; i++) {
            if (this.items[i].index === index) {
                return i + 1;
            }
        }
    }

    get running(): boolean {
        return this.active && this.items.length > 0;
    }

    get hasItems(): boolean {
        return this.items.length > 0;
    }

    items: QueueItem[];
    active: boolean = true;
}
